import React from "react";
import { Button, DatePicker, Panel } from "rsuite";
import Table from "../../components/Table";
import { updateAdmin } from "../../store/modules/admin/actions";
import { useDispatch, useSelector } from "react-redux";
import { updateCliente } from "../../store/modules/cliente/actions";

export default function ClientesList() {
  const dispatch = useDispatch();
  const { form, components } = useSelector((state) => state.admin);
  const { clientes, cliente } = useSelector((state) => state.cliente);

  const setComponent = (component, state) => {
    dispatch(
      updateAdmin({
        components: { ...components, [component]: state },
      })
    );
  };

  return (
    <div className="d-flex flex-column m-0 p-0 col-12 col-xl-12 bg-white  ">
      <div className="d-flex flex-column ">
        <Button color="green" appearance="primary" size="xs">
          {" "}
          Cadastrar Cliente
        </Button>
        <Table
          className="col-12 col-xl-12  bg-white "
          loading={form.filtering}
          data={clientes}
          config={[
            {
              label: "id",
              key: "id",

              width: 50,
            },
            {
              label: "nome",
              key: "name",

              width: 200,
            },
            {
              label: "email",
              key: "email",
              width: 200,
            },
            {
              label: "cpf",
              key: "cpf",
              width: 200,
            },
            {
              label: "phone_number",
              key: "phone_number",
              width: 200,
            },
            {
              label: "address",
              key: "address",
              width: 200,
            },
            {
              label: "address_number",
              key: "address_number",
              width: 200,
            },
            {
              label: "address_zipcode",
              key: "address_zipcode",
              width: 200,
            },
          ]}
          actions={(cliente) => (
            <Button color="blue" appearance="primary" size="xs">
              Ver informções
            </Button>
          )}
          onRowClick={(cliente) => {
            dispatch(
              updateAdmin({
                behavior: "cliente",
              })
            );
            setComponent("drawer", true);

            dispatch(updateCliente({ cliente }));
          }}
        />
      </div>
    </div>
  );
}
